import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SnapshotInvalid } from '../../../style';
import { Heading } from '@salecycle/ui-component-library';

const SnapshotInvalidInfoPanel = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
`;

export const SnapshotInvalidView = () => {
  const { t } = useTranslation('designs');

  return (
    <SnapshotInvalid data-testid="SnapshotInvalidView">
      <SnapshotInvalidInfoPanel>
        <Heading>{t('designs:designGallery.templateEditor.snapshotInvalidView.text')}</Heading>
      </SnapshotInvalidInfoPanel>
    </SnapshotInvalid>
  );
};
